// extracted by mini-css-extract-plugin
export default {"variableSizeList":"CardList_variableSizeList__ICUwM"};